var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhiteLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.479,
    height: 208.77,
    viewBox: "0 0 204.479 208.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53085",
    "data-name": "Group 53085",
    transform: "translate(-403.438 -500.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M841.075,1983.8s-28.868-50.6-81.164-54.831-90.575,54.831-90.575,54.831,20.793,30.168,69.855,48.946",
    transform: "translate(-249.527 -1416.402)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M669.335,1977.7s28.867,50.595,81.164,54.83,90.575-54.83,90.575-54.83-20.792-30.167-69.855-48.947",
    transform: "translate(-249.527 -1335.649)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteLogin);
export default __webpack_public_path__ + "static/media/logo-white-login.286653fca01443428537847087dbdae4.svg";
export { ForwardRef as ReactComponent };